import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import muster from "../../Assets/Projects/muster.png";
import sharezone from "../../Assets/Projects/sharezone.png";
import contestHost from "../../Assets/Projects/contest.png";
import helper from "../../Assets/Projects/helper.png";
import library from "../../Assets/Projects/library.png";
import blog from "../../Assets/Projects/blog.png";
function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>

        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={muster}
              isBlog={false}
              title="Muster (MileStone)"
              description=" Fusion of
              components like File handling, Note System, People gathering, Real Time Communication with text and speech to text
              conversion, Real time notification and invitations with Authentication for better work-space management and team-building
              activities."
              isLink={true}
              tech="ReactJs, NodeJs, MongoDB, ExpressJs, RESTApi, Redux, Socket.io, Google TTS"
              link="https://muster.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={sharezone}
              isBlog={false}
              title="Sharezone (MileStone)"
              description="Lavish UI for User Interaction, Networking System, real time
              communication, notifications, with other multifaceted features like comments, reply & likes.
              "
              tech="Angular, NodeJS, REST API, MongoDB, Socket.io."
              isLink={true}
              link="https://fine-jade-llama-wrap.cyclic.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={blog}
              isBlog={false}
              title="NikBlog"
              description="This project is my first project which i created in flask, In this Platform user can Create Blogs and also support CRUD operations."
              tech="Python, flask, Sql"
              isLink={true}
              link="https://nikblog23.herokuapp.com/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={contestHost}
              isBlog={false}
              title="Contest Hosting"
              description="In this Platform user can create their own contest, can vote or like to the other contest and also can participate. There is Authentication, Rewards for winner and voting Sysytem."
              tech="NodeJS, Ejs, MongoDB, ExpressJs, Multer"
              isLink={false}
              link="https://github.com/nishant23122000/contest_pro"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={library}
              isBlog={false}
              title="Book Library"
              description="Users can add their own books by providing some basic book information, others can also add books in their own locker. Authentication is also provided."
              tech="NodeJS, Ejs, MongoDB, ExpressJs, Multer"
              isLink={false}
              link="https://github.com/nishant23122000/library"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={helper}
              isBlog={false}
              title="Helper"
              description="This Project is my first NodeJS project where users can book services for house/work assistance. Access and seeking help is easier, as only a form input is required."
              tech="NodeJS, Ejs, ExpressJs, Multer"
              isLink={false}
              link="https://github.com/nishant23122000/helper"
            />
          </Col>
          {/* <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Editor.io"
              description="Online code and markdown editor build with react.js. Online Editor which supports html, css, and js code with instant view of website. Online markdown editor for building README file which supports GFM, Custom Html tags with toolbar and instant preview.Both the editor supports auto save of work using Local Storage"
              link="https://github.com/soumyajit4419/Editor.io"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="Ai For Social Good"
              description="Using 'Natural Launguage Processing' for the detection of suicide-related posts and user's suicide ideation in cyberspace  and thus helping in sucide prevention."
              link="https://github.com/soumyajit4419/AI_For_Social_Good"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Face Recognition and Emotion Detection"
              description="Trained a CNN classifier using 'FER-2013 dataset' with Keras and tensorflow backened. The classifier sucessfully predicted the various types of emotions of human. And the highest accuracy obtained with the model was 60.1%.
              Then used Open-CV to detect the face in an image and then pass the face to the classifer to predict the emotion of a person."
              link="https://github.com/soumyajit4419/Face_And_Emotion_Detection"
            />
          </Col> */}
        </Row>

      </Container>
    </Container>
  );
}

export default Projects;
